export interface UpdateBespokeRatingValues {
  startDate: Date
  maxLimitShort: number
  maxLimitLong: number
  maxMoneyLimitShort: number
  maxMoneyLimitLong: number
}

export const updateBespokeRatingInitialValues: UpdateBespokeRatingValues = {
  startDate: null,
  maxLimitShort: 0,
  maxLimitLong: 0,
  maxMoneyLimitShort: 0,
  maxMoneyLimitLong: 0,
}
